var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"text-center p-0",staticStyle:{"justify-content":"center"},attrs:{"fluid":"sm"}},[_c('div',{staticClass:"text-center"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }